module.exports = __webpack_public_path__ + "img/facade-classic-single.9d103dc9.jpeg";